module.exports = __webpack_public_path__ + "media/images/tokyo_station-ac3ef29473b73a4e46cf94da4c05f9f5.jpg";